/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-12 09:43:37 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-12-19 11:50:27
 */
<template>
    <div class="mainBody" v-cloak>
        <div v-if="noYwy == 'hasywy'">
        <div class="header">协议快递员</div>
        <div class="infoBox">
           <div class="top">
               <div class="ImgBox">
                  <img src="../assets/images/user_photo_icon.png">
               </div>
               <div class="nTelAdress">
                   <p>{{name}} <span v-show="teammember">团队共享</span></p>
                   <p style="color:#999999;font-size:12px">协议快递员 
                    <b v-show="auth_type === 0" style="color:red;margin-left:10px;font-weight:normal;">待审核</b>
                   </p>
               </div>
               <div class='ghbindYwy' v-if="mail_limit_rule == 'day'">今日已使用<span>{{usedNum}}</span>个，剩余<span>{{balanceNum}}</span>个</div>
           </div>
           <div class="bottom">
                <div class="allotrow">
                    <div class="left"><span>所属网点：</span></div>
                    <div class="right">{{address}}</div>
                </div>
                <div class="allotrow">
                    <div class="left"><span>网点地址：</span></div>
                    <div class="right">{{netaddress}}</div>
                </div>
                <div class="allotrow" v-if="month_balance_code">
                    <div class="left">寄付月结账号：</div>
                    <div class="right">{{month_balance_code}}
                        <i class="el-icon-copy-document sb_pointer"
                            v-clipboard:copy="month_balance_code"
                            v-clipboard:success="onCopy"
                        ></i>
                    </div>
                </div>
                <div class="allotface" v-if="mail_limit_rule == 'total'">
                 <div class="left">授权面单余量</div>
                 <div class="right">{{limitNum-usedNum}}个</div>
               </div>
               <div class="allotface" v-else>
                 <div class="left">每日授权分配面单量</div>
                 <div class="right">{{limitNum}}个</div>
               </div>
               <div class="allotface">
                 <div class="left">面单授权分配记录</div>
                 <div class="right" @click="lookopt"><span>近12个月的操作记录</span><i class="el-icon-arrow-right"></i></div>
               </div>
               <div class="allotface">
                 <div class="left">快递员面单余额</div>
                 <div class="right" ><span>{{courier_mail_num_balance}}个</span></div>
               </div>
               <div class="loseMoneyTip">* 韵商宝不具备面单充值功能，建议按照实际面单使用量与快递员进行结算，警惕资金流失风险</div>
           </div>
        </div>
        </div>
        <div class="noywy" v-else-if="noYwy=='outywy'">
            <div class="bgBox">
                <img src="https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=bindkdybg.png"/>
            </div>
            <div class="xcxcode"><img :src="bindxcxImg"/></div>
            <div class="des">微信扫码申请绑定协议快递员</div>
        </div>
        <div v-else></div>
        <el-dialog
            v-if="centerDialogVisible"
            title="面单授权分配记录"
            :visible.sync="centerDialogVisible"
            width="600px"
            center>
            <div class="allotDialog">
                <div class="total">{{start_time}} 至 {{end_time}} 共{{total}}条记录</div>
                <div class="bindItem" v-for="(item,index) in ywy_records" :key="index"> 
                    <div class="top">绑定快递员：{{item.ywy_name}}</div>
                    <div v-for="(c,indexs) in item.record_list" class="itemopt" :key="indexs">
                        <div>{{c.create_time }}</div>
                        <div>{{c.opt_message}}</div>
                        <div>{{c.left_message}}</div>
                    </div>
                </div>
            </div>
        </el-dialog>        
    </div>
</template>
<script>
import util from '@/util/util';
import face from '@/api/face';
import team from "@/api/team";
import  teamMix  from '@/mixin/teamMix';
export default {
    name:'faceSheet',
    mixins: [teamMix],
    data(){
        return{
            name:'',
            phone:'',
            month_balance_code:'',
            address:'',
            netaddress:'',
            auth_type:'',
            balanceNum:0,
            usedNum:0,
            limitNum:0,
            cancelNum:0,
            noYwy:'',
            centerDialogVisible:false,
            start_time:'',
            end_time:'',
            total:0,
            ywy_records:[],
            mail_limit_rule:'day',
            teammember:false,
            bindxcxImg:'',
            courier_mail_num_balance:''
        }
    },
    methods:{
        /** 一键复制 */
        onCopy(e) {
        this.$message({
            message: "寄付月结账号: " + e.text + " 复制成功",
            type: "success",
        });
        },
        //查看记录
        lookopt(){
          this.centerDialogVisible = true;
          let time = util.getlimiTime(0).split("-");
          this.start_time = time[0]-1 + '-' + time[1] + '-' + time[2] 
          this.end_time = util.getlimiTime(0)
          const query = {
            account_id: util.getCookie("account_id"),
            start_time:this.start_time + ' 00:00:00',
            end_time:this.end_time + ' 23:59:59',
          } 
          face.getauthorizRecords(this,query).then(res=>{
            if(res.success){
                let data = res.data;
                this.total = data.total
                this.ywy_records = data.ywy_records
            }
          })
        },
        //绑定业务员
        bindYwy(){
          if(this.noYwy == 'outywy'){
            this.$router.push({path:'./bindywy'})
          }else{
            this.$confirm("更换绑定后，原有的面单余量将清除同时解除现已绑定的快递员", '提示', {
              confirmButtonText: '去换绑',
              cancelButtonText: '再考虑下',
              type: 'warning'
            }).then(() => {
              this.$router.push({path:'./bindywy'})
            }).catch(() => {         
            });
          }
        },
        goerrorTip(){
          const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
          if(Obstruct){
             const Item = JSON.parse(Obstruct).teamAddress
             window.open(Item)
          }
        },
        //获取角色信息
        getRole(){
            team.pretReatment(this).then(res=>{
            if(res.success){
                const type = res.data;
                if(type == 2 && this.$store.state.teamModel == 2){this.teammember=true}else{this.teammember=false}
            }
            })
        },
        //获取协议面单信息        
        loadData(){
          face.getbillNum(this).then(res=>{
             if(res.success){
                 const data = res.data;
                 this.balanceNum = data.mail_num_balance;
                 this.usedNum = data.mail_num_used;
                 this.limitNum = data.mail_num_limit;
                 this.cancelNum = data.mail_num_cancel;
                 this.name = data.ywy_name;
                 this.phone = data.ywy_phone;
                 this.address = data.branch_name;
                 this.netaddress = data.gs_address,
                 this.month_balance_code = data.month_balance_code
                 this.auth_type = data.auth_type;
                 this.mail_limit_rule = data.mail_limit_rule;
                 this.courier_mail_num_balance = data.courier_mail_num_balance;
                 this.noYwy = 'hasywy'
                 if(data.auth_type == 4){
                  this.$confirm('该快递员账号异常已自动解绑，请重新绑定其他快递员', '提示', {
                    confirmButtonText: '重新绑定',
                    cancelButtonText: '我知道了',
                    type: 'warning',
                    center: true
                  }).then(() => {
                    this.$router.push({path:'./bindywy'})
                  }).catch(() => {}); 
                 }
             }else{
                 if(res.data.code == 7006){
                   this.noYwy = 'outywy';
                 }
             }
          }) 
        }
    },
    mounted(){
        // this.getInfo();
        this.loadData(); 
        this.getRole();
        if(util.jgEnv() == 'pro'){
          this.bindxcxImg = 'https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=releasebindkdy.png'
        }else{
          this.bindxcxImg = 'https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=testbindkdy.png'
        }
    }
}
</script>
<style lang="stylus" scoped>
[v-cloak]{
  display: none;
}
.mainBody{
    padding 10px 30px
}
.header{
    font-size 16px;
    font-weight bold
    border-bottom  1px solid #DCDFE6  
    line-height 50px
    color #2ea2fc   
}
.infoBox{
    font-size 14px  
    padding-top: 30px;
    .top{
        display: flex;
        justify-content: flex-start;
        margin: 0 50px;
        position: relative;
        width: 380px;
        .ImgBox{
            width: 60px;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;       
            img{
                width 100%
            }    
        }  
        .nTelAdress{
            padding-top:10px
            margin-left:30px
            line-height: 30px   
            span{
                border-radius: 20px;
                background: rgba(255,191,0,1);
                font-size: 12px;
                padding: 2px 6px;
                font-weight: normal;
                margin-left:10px;
            }
        }  
        .ghbindYwy{
            position: absolute;
            cursor:pointer;
            right:0px;
            height:30px;
            font-size: 12px; 
            color:#666666;
            text-align: right;
            line-height: 30px;
            top:12px;
            span{
                color:#222222;
            }
        }   
    }
    .bottom{
        margin-left: 60px;
    }
}
.allotface{
    display: flex;
    width: 380px;
    justify-content: space-between;
    margin-top: 10px;
    line-height: 30px;
    cursor pointer
    span{
        font-size: 12px
    }
}
.allotrow{
    display: flex;
    width: 380px;
    justify-content: flex-start;
    margin-top: 10px;
    line-height: 30px;
    cursor pointer
    span{
        color:#999999
    }
}
.loseMoneyTip{
    width: 380px;
    font-size: 12px;
    color: #FF6010;
    margin-top: 10px;
}
.allotDialog{
    height: 400px;
    overflow-y: auto;
    .total{
        height: 30px;
        padding-left: 25px;
        line-height: 30px;
      }
      .bindItem{
        background-color: #fff;
        margin: 0 10px 20px 10px;
        border-radius: 4px;
        padding: 0 15px;
        font-size: 14px;
        line-height: 30px;
      }
      .bindItem .top{
        border-bottom: 1px solid #DCDFE6;
      }
      .bindItem .itemopt{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #DCDFE6;
      }
      .bindItem .itemopt view{
        width: 33%;
        /* text-align: left; */
      }
}

.noywy{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  .bgBox{
    width: 582px;
    height: 136px;
    border-radius: 12px;
    margin-top: 40px;
    margin-bottom: 20px;
    img{
        width: 100%
        height: 100%
    }
  }
  .xcxcode{
    width: 200px;
    height: 200px;
    img{
        width: 100%;
        height: 100%
    }
  }
  .des{
    width: 220px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    border-radius: 8px;
    opacity: 1;
    background: rgba(245,245,245,1);
    text-align: center
    margin-top: 20px;
  }
}
</style>